module.exports = __webpack_public_path__ + "img/MEME.6c7d9568.png";